import React from 'react'

import { Link } from "react-router-dom";
import dogfood from "../images/dog food photo.jpg"
import Header from '../inc/Header';

function Aboutus() {
    return (
        <div>
            <Header/>
            <br />
            <br />
            <br />
            <br />
        
            <div className='petprescriptionupload'>
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>

                                <li className="breadcrumb-item active" aria-current="page">About us</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br />
            <div className="album py-1 ">
                <div className="container">
                    <div className="row">

                        <div className="col-md-7 mt-2">
                            <h1 style={{ color: "rgba(41, 15, 12, 1)" }}>About Us –<b style={{color:"#CC000A"}}> Pet Plazza</b></h1>
                            <p className='about'>At Pet Plazza, we believe pets are more than just companions – they’re family. That’s why we’ve created a one-stop destination in the heart of Krishnanagar where every pet parent can find trusted food, quality accessories, and everyday essentials for their furry, feathery, or finned friends.</p>
                            <p className='about'>Located opposite HP Petrol Pump, near Municipality More, Krishnanagar, we bring convenience, care, and compassion together under one roof. From nutritious pet food to stylish accessories, from grooming must-haves to playful toys – everything here is handpicked to keep tails wagging and hearts happy.</p>

                            <p className='about'><small>What makes us unique is our personal touch – we don’t just sell products, we guide pet parents with genuine advice, helping them choose the best for their little ones. Whether you’re a first-time pet owner or an experienced animal lover, Pet Plazza is your trusted partner in every step of your pet journey.</small></p>         
                            
                                           </div>
                
                    <div className="col-md-5 mt-2">
                        <img src={dogfood} className="card-img-top" alt="dogfood" />
    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Aboutus